var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 24H5.49998C2.4638 23.9967 0.00332812 21.5362 0 18.5V5.49998C0.00332812 2.4638 2.4638 0.00332812 5.49998 0H18.5C21.5362 0.00332812 23.9967 2.4638 24 5.49998V18.5C23.9967 21.5362 21.5362 23.9967 18.5 24ZM5.49998 3C4.11928 3 3 4.11928 3 5.49998V18.5C3 19.8807 4.11928 21 5.49998 21H18.5C19.8807 21 21 19.8807 21 18.5V5.49998C21 4.11928 19.8807 3 18.5 3H5.49998Z",
    fill: "#3F45EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 17.7872C9.03596 17.7876 8.43099 17.5355 7.98699 17.0872L4.99998 14.1052C4.41399 13.5196 4.41371 12.5698 4.99932 11.9838C4.99956 11.9836 4.99979 11.9834 4.99998 11.9831C5.58573 11.3976 6.53523 11.3976 7.12098 11.9831L9.66699 14.5281L16.879 7.31612C17.4647 6.73056 18.4142 6.73056 19 7.31612C19.586 7.90173 19.5863 8.85147 19.0006 9.43745C19.0004 9.43769 19.0002 9.43792 19 9.43811L11.346 17.0921C10.9015 17.5386 10.297 17.7889 9.66699 17.7872Z",
    fill: "#3F45EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusApproved);
export default __webpack_public_path__ + "static/media/status-approved.ffb93b49029bf7bff0a4faa33a16665c.svg";
export { ForwardRef as ReactComponent };